var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-43d3f432\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":false}!sass-resources-loader?{\"resources\":\"/home/runner/work/rosetta_web_platform/rosetta_web_platform/src/assets/style/_variables.scss\"}!../../../node_modules/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/node_modules/vue-loader/lib/selector?type=styles&index=0!./Dictionary.vue")
}
var Component = require("!../../../node_modules/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/node_modules/vue-loader/lib/selector?type=script&index=0!./Dictionary.vue"),
  /* template */
  require("!!../../../node_modules/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-43d3f432\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../node_modules/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/node_modules/vue-loader/lib/selector?type=template&index=0!./Dictionary.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/rosetta_web_platform/rosetta_web_platform/src/components/dictionary/Dictionary.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Dictionary.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-43d3f432", Component.options)
  } else {
    hotAPI.reload("data-v-43d3f432", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/dictionary/Dictionary.vue
// module id = 279
// module chunks = 1